const o=(o,t,c)=>c>t?t:c<o?o:c;export{o as clamp};
